export class UserDto {
	public userId: string = "";
	public customerId: number = 0;
	public firstname: string = "";
	public lastname: string = "";
	public phone: string = "";
	public eMail: string = "";
	public newsletterSubscribed: boolean = false;
	public confirmed: boolean = false;
	public active: boolean = true;
	public canManageUsers: boolean = false;
	public canChangeDeliveryAddress: boolean = false;
	public canChangeInvoiceAddress: boolean = false;
	public canOrderDirectly: boolean = false;
	public canOrderIndirectly: boolean = false;
	public funktion: string = "";
}
